<template>
  <v-container class="pa-0" fluid>
    <paginated-data-table
      :key="paginatedDataTableKey"
      ref="table"
      :headers="prizesTableHeader"
      :search="search"
      :query="query"
      :query-variables="customQueryVariables"
      query-main-property-name="raffleParticipants"
      query-name="raffleParticipants"
      @update-options="updateVariables"
    >
      <template slot="no-data">
        <span>{{ emptyTableMessage }}</span>
      </template>
      <template v-slot:header.manually_generated>
        <mf-tooltip bottom max-width="250px">
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on">
              Modo de Geração
              <v-icon small class="ml-1">mdi-information-outline</v-icon>
            </span>
          </template>
          <span>Indica se o número foi gerado automaticamente via processamento da venda do clube, ou manualmente via upload manual na tela de sorteio.</span>
        </mf-tooltip>
      </template>
      <template v-slot:item="{ item, index, props }">
        <tr :key="item + index" class="cinza-l90">
          <td class="table-text--gray">{{ item.lucky_number.number | localeString }}</td>
          <td class="table-text--gray">
            <span>{{ item.user.name }}</span>
          </td>
          <td class="table-text--gray">{{ item.user.document_no | cpfCnpj }}</td>
          <td class="table-text--gray">
            <span>{{ item.lucky_number.unit.name }}</span>
          </td>
          <td class="table-text--gray">
            <span>{{ item.lucky_number.created_at | date({ fmtIn: 'yyyy-mm-dd', fmtOut: 'dd/mm/yyyy' }) }}</span>
          </td>
          <td class="table-text--gray">
            <span>{{ item.lucky_number.manually_generated ? 'Manual' : 'Automático' }}</span>
          </td>
          <td class="blue-action-text" v-bind="props" @click="showParticipantDetails(item)">Detalhes</td>
        </tr>
      </template>
    </paginated-data-table>
  </v-container>
</template>

<script>
import PaginatedDataTable from '@/components/PaginatedDataTable.vue'
import { diacriticSpaceSensitiveRegex } from '@/helpers/search.js'
import { QUERY_PAGINATED_RAFFLE_PARTICIPANTS } from '@/modules/mobile/sorteio/graphql'

export default {
  name: 'RaffleParticipantsTable',
  components: {
    PaginatedDataTable,
  },
  props: {
    emptyTableMessage: {
      type: String,
      required: true,
    },
    search: {
      type: String,
      required: true,
    },
    raffleId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    options: {},
    showTooltipName: {},
    showTooltipUnit: {},
    queryVariables: {
      sort: ['number'],
      sortDirection: ['ASC'],
    },
    prizesTableHeader: [
      {
        text: 'Número da sorte',
        value: 'number',
        sortable: true,
      },
      {
        text: 'Nome',
        value: 'name',
        sortable: false,
      },
      {
        text: 'CPF/CNPJ',
        value: 'document_no',
        sortable: false,
      },
      {
        text: 'Loja',
        value: 'unit_name',
        sortable: false,
      },
      {
        text: 'Data de criação',
        value: 'created_at',
        sortable: false,
      },
      {
        text: 'Modo de distribuição',
        value: 'manually_generated',
        sortable: false,
      },
      {
        text: '',
        value: '',
        sortable: false,
      },
    ],
    paginatedDataTableKey: 0,
  }),
  computed: {
    query() {
      return QUERY_PAGINATED_RAFFLE_PARTICIPANTS
    },
    customQueryVariables() {
      return { raffle_id: this.raffleId, ...this.queryVariables }
    },
  },
  methods: {
    showParticipantDetails(item) {
      this.$emit('show-details', item)
    },
    filterItemsBySearch(item, search) {
      const searchRegex = diacriticSpaceSensitiveRegex(search)
      return (
        item.lucky_number.number.toString().match(searchRegex) ||
        item.lucky_number.unit.name.match(searchRegex) ||
        item.user.name.match(searchRegex) ||
        item.user.document_no.match(searchRegex)
      )
    },
    updateVariables(newQueryOptions) {
      const { sortBy, sortDesc } = newQueryOptions
      if (sortBy.length && sortDesc.length) {
        this.queryVariables.sort = sortBy
        this.queryVariables.sortDirection = sortDesc[0] ? ['DESC'] : ['ASC']
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.blue-action-text {
  color: $marca-0-l40;
  text-decoration: underline;
  text-align: center;
  &:hover {
    cursor: pointer;
  }
}
.table-text--gray {
  color: '#545454';
  font-size: 12px;
}
</style>
